<script>
    export default {
        props: {
            uploadMethod: Function,
        }
    }
</script>


<template>
    <input 
        @change="uploadMethod"    
        type="file"
        accept=".jpg, .jpeg, .png, .svg, .icon"
        class="upload_image_button"
        id="input_file"
    >
    <label 
        for="input_file" 
        class="fake_upload_image_button"
    >Select Image To Upload</label>
</template>